import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import clsx from 'clsx';

const JA_KIOSK_FEEDBACK_FORM_SOURCE_SITE_ID =
  process.env.REACT_APP_JA_KIOSK_FEEDBACK_FORM_SOURCE_SITE_ID;

export const FeedbackButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <NavLink
      to={`/forms/${JA_KIOSK_FEEDBACK_FORM_SOURCE_SITE_ID}`}
      className="fixed bottom-6 right-6 z-50 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative">
        <div className="bg-cyan-500 hover:bg-cyan-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out transform hover:scale-110">
          <MessageCircle
            className={clsx(
              'w-6 h-6 transition-transform duration-300',
              isHovered ? 'rotate-12' : 'rotate-0',
            )}
          />
        </div>

        <div className="absolute inset-0 rounded-full bg-cyan-500 animate-ping opacity-20" />
      </div>

      <div
        className={clsx(
          'absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-all duration-300',
          isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none',
        )}
      >
        Share Feedback
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
          <div className="border-8 border-transparent border-l-gray-900" />
        </div>
      </div>
    </NavLink>
  );
};
